// import { TranslationMessages } from "ra-core";
import englishMessages from "ra-language-english";

const orderFields = {
  "contact.id": "Customer ID",
  customerName: "Customer",
  "contact.remarks": "Contact Remarks",
  status: "Status",
  shippingOption: "Shipping Method",
  merchandiseTotal: "Merchandise Total",
  outstandingPayment: "Outstanding Payment",
  weight: "Weight",
  shippingPostcode: "Postal Code",
  currencyCode: "Currency",
  deliveryOrderPrinted: "Delivery Order Printed",
  createdAt: "Created At",
  updatedAt: "Updated At",
  email: "Email",
  description: "Order Description",
  notes: "Customer Notes",
  invoiceNumber: "Invoice Number",
  orderNumber: "Order Number",
  overrideShippingCost: "Shipping Cost Overridden",
  shippingAddress1: "Shipping Address 1",
  shippingAddress2: "Shipping Address 2",
  shippingCity: "Shipping City",
  shippingCost: "Shipping Cost",
  shippingCountry: "Shipping Country",
  shippingName: "Shipping Name",
  shippingPhoneNumber: "Shipping Phone Number",
  shippingProvince: "Shipping Province",
  shippingState: "Shipping State/Province",
  shippingSubDistrict: "Shipping Subdistrict/Street",
  shippingVillage: "Shipping Village/Community",
  trackingNumber: "Tracking Number",
};

const customEnglishMessages = {
  ...englishMessages,
  pos: {
    search: "Search",
    configuration: "Settings",
    language: "Language",
    settings: {
      billing: "Billing",
      accounts: "Accounts",
      settings: "Settings",
      logout: "Logout",
      plan_expired: "System Expired",
      panel: {
        shipping_rules: "Shipping Rules",
        important_info: "Important Information",
        parameters: "Parameters",
        pin_comment_template: "Pinned Comment Template",
        payment_msg: "Payment Message",
        order_notification: "Order Notification",
        shipped_notification: "Shipped Notification",
        self_collect_notification: "Self-Collect Notification",
        webstore: "Webstore",
        payment_methods: "Payment Methods",
        marketing_messages: "Marketing Messages",
        shipping_profiles: "Shipping Profiles",
        ninjavan: "Ninja Van",
        tnc: "Terms & Conditions",
        privacy_policy: "Privacy Policy",
        shipping_policy: "Shipping Policy",
        refund_policy: "Refund Policy",
        about_us: "About Us",
        contact_us: "Contact Us",
        gpt_settings: "GPT Settings",
        bukku_settings: "Bukku Settings",
      },
      important_info: {
        profile_settings: "Account Settings",
        message_template: "Message Template",
        change_logo: "Change Logo",
        message_editor: "Message Editor",
        preview: "Preview",
        save_button: "Save",
        insert_image: "Insert Image",
        save_template: "Save Template",
      },
      parameters: {
        settings_configuration: "Settings Configuration",
        do_invoice_fields: "DO & Invoice Settings",
        delivery_order_shows_price: "Delivery Order Shows Price",
        delivery_order_hides_unit_price: "Delivery Order Hides Unit Price",
        delivery_order_show_total_weight: "Delivery Order Shows Total Weight",
        delivery_order_use_invoice_label: "Delivery Order Uses Invoice Label",
        delivery_order_show_order_number_barcode:
          "Delivery Order Shows Order Number Barcode",
        invoice_show_order_number_barcode: "Invoice Shows Order Number Barcode",
        show_image_in_do_inv: "Show Images in DO/INV",
        enable_thermal_receipt: "Enable Thermal Receipt",
        sort_items_alphabetically: "Sort Items Alphabetically",
        waitlists: "Waitlists",
        enable_waitlists: "Enable Waitlists",
        general_settings: "General Settings",
        date_format: "Date Format",
        default_country_code: "Default Country Code",
        currency: "Currency",
        shipping_countries: "Shipping Countries",
        shipping_countries_description:
          "Select shipping countries. By default, all countries are available for shipping.",
        shipping_countries_placeholder: "Select Country",
        shipping_countries_helper_text: "",
        likes_comment_order_successfully:
          "Like comment order successful. Note: FB may restrict your page; use at your own risk.",
        enable_live_bidders_name_list_every_3_minutes:
          "Enable Live Bidder List Every 3 Minutes",
        enable_hide_comment_upon_successful_bid:
          "Enable Hiding Comment After Successful Bid",
        enable_shopping_cart: "Enable Shopping Cart",
        enable_customer_cancel: "Enable Customer Cancellation",
        disable_customer_special_notes: "Disable Customer Special Notes",
        enable_web_shop: "Enable Webstore",
        enable_web_store_display_out_of_stock_products:
          "Enable Display of Out-of-Stock Products in Webstore",
        enable_capture_message: "Enable Message Capture",
        order_notification_shows_unit_price:
          "Order Notification Shows Unit Price",
        disable_order_notification_message_on_messenger:
          "Disable Order Notification Message in Messenger",
        enable_out_of_stock_notification: "Enable Out-of-Stock Notification",
        allow_admin_delete_orders: "Allow Admin to Delete Orders",
        allow_to_edit_completed_orders: "Allow Editing Completed Orders",
        allow_manual_add_item_with_inactive_keyword:
          "Allow Manually Adding Inactive Keywords",
        only_admin_can_edit_credit: "Only Admin Can Edit Credit",
        disable_sell_on_ig: "Disable IG Sales",
        disable_assistant_from_viewing_sales_table_in_live_window:
          "Disable Assistant from Viewing Sales Table in Live Window",
        disable_tracking_plugin: "Disable Tracking Plugin",
        enable_credit_payment: "Enable Credit Payment",
        enable_fake_cancel_message_on_status_locked:
          "Enable Fake Cancel Message When Status Locked",
        enable_show_weight_in_shopping_cart:
          "Enable Show Weight in Shopping Cart",
        disable_shipping_notification_message:
          "Disable Shipping Notification Message",
        disable_manual_force_send_shopping_cart:
          "Disable Manual Force Send Shopping Cart",
        allow_forcefully_send_shipping_message:
          "Allow Force Sending of Shipping Message",
        keywordsessionQuantityValidationSeconds:
          "Keywords max quantity limitation(seconds)",
      },
      webstore: {
        add_shop_now_button: "Add Shop Now Button",
        add_shop_now_button_description:
          "Copy the link below and follow the instructions to set it as your Shop Now button.",
        copy_webstore_link: "Copy Webstore Link",
        add_get_started_button: "Add Get Started Button",
        add_webstore_link: "Add Webstore Link",
        add_webstore_link_description: "Add Webstore Link",
        welcome_message_template: "Welcome Message Template",
        add_get_started_button_to_messenger:
          "Add Get Started Button to Messenger",
        add_get_started_button_to_messenger_description:
          "You must have a 'Get Started' button for new users to see your webstore.",
        add_get_started_button_to_messenger_step_1: "Click 'Check'",
        add_get_started_button_to_messenger_step_2:
          "If the button doesn’t exist, click 'Add Get Started'",
      },
    },
    dashboard: {
      today_sales: "Today's Sales",
      monthly_revenue: "Monthly Revenue",
      pending_revenue: "Pending Revenue",
      month_history: "Last 30 Days Revenue History",
      new_orders: "New Orders",
      pending_reviews: "Pending Reviews",
      new_customers: "New Customers",
      pending_orders: "Pending Orders",
      order: {
        items:
          "From %{customer_name}, 1 item |||| From %{customer_name}, %{nb_items} items",
      },
      welcome: {
        title: "Welcome to Boxify FB Live System",
        subtitle: "",
        aor_button: "Have a question? Try the Help Center",
        button2: "Contact Us",
      },
    },
    menu: {
      sales: "Sales",
      catalog: "Catalog",
      customers: "Customers",
    },
  },
  resources: {
    contacts: {
      name: "Customers",
      fields: {
        name: "Name",
        channel: "Channel",
        phoneNumber: "Phone Number",
        isBlacklisted: "Blacklisted",
        remarks: "Remarks",
        rating: "Rating",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    orders: {
      name: "All Orders",
      fields: orderFields,
    },
    activeorders: {
      name: "Active Orders",
      fields: orderFields,
    },
    paidorders: {
      name: "Paid Orders",
      fields: orderFields,
    },
    waitingforpaymentorders: {
      name: "Awaiting Payment",
      fields: orderFields,
    },
    "ready-to-ship-orders": {
      name: "Ready to Ship",
      fields: orderFields,
    },
    payments: {
      name: "Payments",
      fields: {
        "order.customerName": "Customer",
        "order.shippingName": "Recipient",
        "order.orderNumber": "Order Number",
        "order.status": "Order Status",
        type: "Payment Type",
        paidAmount: "Amount",
        "order.invoiceNumber": "Invoice Number",
        remarks: "Remarks",
        paid: "Paid",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    orderItems: {
      name: "Order Items",
      fields: {
        description: "Product Description",
        "keyword.key": "Keyword",
        "order.customerName": "Customer",
        channel: "Channel",
        status: "Status",
        price: "Price",
        "order.status": "Order Status",
        tags: "Tags",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    keywords: {
      name: "Keywords",
      fields: {
        description: "Product Description",
        key: "Keyword",
        sku: "SKU",
        isActive: "Active",
        currencyCode: "Currency",
        price: "Price",
        tieredPrices: "Tiered Prices",
        webTieredPrices: "Web Tiered Prices",
        webPrice: "Web Price",
        stock: "Stock",
        stockLeft: "Stock Left",
        vipTier: "VIP Tier",
        allowBackorder: "Allow Backorder",
        weight: "Weight (kg)",
        cost: "Cost",
        detail: "Detail",
        allowInWeb: "Allow on Website",
        categories: "Categories",
        variants: "Variants",
        minQuantity: "Minimum Order Quantity",
        maxQuantity: "Maximum Order Quantity",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    webstore: {
      name: "Webstore",
    },
    categories: {
      name: "Categories",
      fields: {
        description: "Description",
        label: "Label",
        position: "Position",
        allowInWeb: "Allow in Web",
        createdAt: "Created At",
        updatedAt: "Updated At",
        selections: "Options",
      },
    },
    variants: {
      name: "Variants",
      fields: {
        description: "Description",
        label: "Label",
        colorCode: "Color",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    selections: {
      name: "Selections",
      fields: {
        description: "Description",
        label: "Label",
        variants: "Variants",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    others: {
      name: "Others",
    },
    tools: {
      name: "Tools",
    },
    vouchers: {
      name: "Vouchers",
      fields: {
        code: "Voucher Code",
        value: "Value",
        isActive: "Active",
        discountType: "Discount Type",
        discountAfterShipping: "Discount Includes Shipping",
        maxDiscount: "Maximum Discount",
        minPurchaseAmount: "Minimum Purchase Amount",
        maxUsage: "Maximum Usage",
        maxUsagePerCustomer: "Max Usage per Customer",
        usedCount: "Used Count",
        expiredAt: "Expiry Date",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    tags: {
      name: "Tags",
      fields: {
        description: "Description",
        label: "Label",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    waitlists: {
      name: "Waitlists",
      fields: {
        "contact.name": "Customer",
        description: "Description",
        key: "Keyword",
        quantity: "Quantity",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    exports: {
      name: "Exports",
      fields: {
        _id: "ID",
        params: "Export Parameters",
        recordCount: "Record Count",
        status: "Status",
        download: "Download",
        username: "User",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
    creditlogs: {
      name: "Credit Logs",
      fields: {
        "contact.name": "Customer",
        amount: "Amount",
        "updatedBy.username": "Updated By",
        createdAt: "Created At",
        updatedAt: "Updated At",
      },
    },
  },
};

export default customEnglishMessages;
